import React from 'react';
import { compose, withProps, lifecycle } from 'recompose';
import {
    withScriptjs,
    withGoogleMap,
    GoogleMap,
    Marker
} from 'react-google-maps';
import withCustomTheme from '../HOC/HOCwithCustomTheme.jsx';
import HOCLoader from '../HOC/HOCLoader.jsx';

import { getAddress } from '../../utils/helpers/functions/geocode';

const MyMapComponent = compose(
    withProps({
        //googleMapURL: `https://maps.googleapis.com/maps/api/js?key=AIzaSyCtIZ0E4yzvGqwBYXiNv9DxqvMRqeI3_pg&libraries=geometry,drawing,places`,
        loadingElement: <div style={{ height: `100%` }} />,
        containerElement: <div style={{ height: `400px` }} />,
        mapElement: <div style={{ height: `100%` }} />
    }),
    lifecycle({
        componentWillMount() {
            const refs = {};

            this.setState({
                position: null,
                onMarkerMounted: ref => {
                    refs.marker = ref;
                },

                // onPositionChanged: () => {
                //     const position = refs.marker.getPosition();
                // },
                onDragEnd: async () => {
                    const position = refs.marker.getPosition();

                    var latlongs = position.toString().split(',');
                    var lat = latlongs[0].replace('(', '');
                    var long = latlongs[1].replace(')', '');

                    const addressValue = await getAddress(lat, long);
                    // this.props.getAdress(addressValue);
                    // const address = this.onChangeComplete(position);
                }
            });
        }
    }),
    withScriptjs,
    withGoogleMap
)(props => (
    <GoogleMap defaultZoom={8} defaultCenter={{ lat: 30.45744, lng: 76.45322 }}>
        {props.isMarkerShown && (
            <Marker
                position={{ lat: 30.45744, lng: 76.45322 }}
                draggable={true}
                ref={props.onMarkerMounted}
                // onPositionChanged={props.onPositionChanged}
                onDragEnd={props.onDragEnd}
            />
        )}
    </GoogleMap>
));

class CustomerAddressMap extends React.PureComponent {
    state = {
        isMarkerShown: false
    };

    render() {
        return (
            <div>
                <HOCLoader loading={this.props.isLoading}>
                    <MyMapComponent isMarkerShown={true} />
                </HOCLoader>
            </div>
        );
    }
}

export default withCustomTheme(CustomerAddressMap);



// WEBPACK FOOTER //
// ./src/components/Map/CustomerAddressMap.jsx